// ----------------------------------------------------------------------------
// Snippet: Header menu
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Variables
// -------------------------------------

// Selectors
var HEADER_SELECTOR = '.header';
var HAMBURGER_SELECTOR = '.header__link--menu';
var HEADER_NAV_WRAPPER_SELECTOR = '.header__nav-wrapper';
var MENU_LIST_SELECTOR = '.header-menu__list';
var MENU_ITEM_SELECTOR = '.header-menu__item--dropdown';
var MOBILE_MENU_ITEM_SELECTOR = '.header-menu__list--mobile .header-menu__item--dropdown';
var OPEN_MENU_ITEM_SELECTOR = '.header-menu__item--dropdown.js--is-open';
var DESKTOP_TOP_MENU_ITEM_SELECTOR = '.header-menu__list--desktop .header-menu__item--level-1.header-menu__item--dropdown';
var MENU_TRIGGER_SELECTOR = '.header-menu__trigger';
var MOBILE_MENU_TRIGGER_SELECTOR = '.header-menu__list--mobile .header-menu__trigger';
var DESKTOP_MENU_TRIGGER_SELECTOR = '.header-menu__list--desktop .header-menu__trigger';
var MOBILE_MENU_LINK_SELECTOR = '.header-menu__list--mobile a.header-menu__link';
var DESKTOP_MENU_LINK_SELECTOR = '.header-menu__list--desktop a.header-menu__link';
var DESKTOP_TOP_MENU_LINK_SELECTOR = '.header-menu__list--desktop .header-menu__item--level-1 > a.header-menu__link';
var MOBILE_LEVEL1_TRIGGER_FOCUS_SELECTOR = '.header-menu__list--mobile .header-menu__item--level-1.header-menu__item--dropdown > .header-menu__trigger';
var DESKTOP_LEVEL1_TRIGGER_FOCUS_SELECTOR = '.header-menu__list--desktop .header-menu__item--level-1.header-menu__item--dropdown > .header-menu__trigger';
/** Desktop mega parents: link + hover only (no toggle button). */
var DESKTOP_MEGA_PARENT_SELECTOR = 'a.header-menu__link--mega-parent';
var MENU_BACK_BUTTON_SELECTOR = '.header-menu__back .back__button';
/** Align with `bp(laptop)` / `$container--laptop` (1080px): mobile nav JS below this width only. */
var MOBILE_MENU_MEDIA_QUERY = '(max-width: 1079px)';
var MEGA_PANEL_CLOSE_SELECTOR = '.header-menu__panel-close';

// Classes
var HEADER_NAV_WRAPPER_SLIDE_CLASS = 'mobile-slide';
var LEVEL_1_MENU_ITEM_CLASS = 'header-menu__item--level-1';
var LEVEL_2_MENU_LIST_CLASS = 'header-menu__list--level-2';
var MENU_TRIGGER_CLASS = 'header-menu__trigger';
var MENU_BACK_BUTTON_CLASS = 'back__button';
var MENU_LINK_EMPTY_CLASS = 'header-menu__link--empty';
var OPEN_CLASS = 'js--is-open';
var NO_SCROLL_CLASS = 'noscroll';
var DESKTOP_OPEN_TOP_MENU_ITEM_SELECTOR = '.header-menu__list--desktop .header-menu__item--level-1.header-menu__item--dropdown.' + OPEN_CLASS;
var HEADER_SECTION_SELECTOR = '#shopify-section-header';
var MENU_OPEN_CLASS = 'js--menu-open';

/** Avoid duplicate `scroll` listeners when `initDesktopMenu` runs again (e.g. resize). */
var desktopMenuDocumentScrollCloseBound = false;

// Key codes
var INTERACTION_KEYS = [' ', 'Enter', 'Escape', 'Tab'];

/** Desktop dropdown hover: bridge crossing time + move into fixed panel before close */
var MENU_HOVER_OPEN_DELAY_MS = 80;
var MENU_HOVER_CLOSE_DELAY_MS = 220;

// -------------------------------------
// Helper functions
// -------------------------------------

function initMobileMenu() {
  var menu = {
    $body: document.querySelector('body'),
    $header: document.querySelector(HEADER_SELECTOR),
    $headerNavWrapper: document.querySelector(HEADER_NAV_WRAPPER_SELECTOR),
    $hamburger: document.querySelector(HAMBURGER_SELECTOR),
    $items: document.querySelectorAll(MOBILE_MENU_ITEM_SELECTOR),
    $buttons: document.querySelectorAll(MOBILE_MENU_TRIGGER_SELECTOR),
    $links: document.querySelectorAll(MOBILE_MENU_LINK_SELECTOR)
  };
  initMenuButtons(menu, 'mobile');
  initMenuLinks(menu, 'mobile');
  initLevelOneTriggerFocus(menu, 'mobile');
}
function initDesktopMenu() {
  var menu = {
    $topLevelItems: document.querySelectorAll(DESKTOP_TOP_MENU_ITEM_SELECTOR),
    $buttons: document.querySelectorAll(DESKTOP_MENU_TRIGGER_SELECTOR),
    $links: document.querySelectorAll(DESKTOP_MENU_LINK_SELECTOR)
  };
  initDesktopHover(menu.$topLevelItems);
  initMenuButtons(menu, 'desktop');
  initMenuLinks(menu, 'desktop');
  initLevelOneTriggerFocus(menu, 'desktop');
  initMegaPanelClose(menu);
  initDesktopMenuDocumentScrollClose();
  setActiveTopLevelLinks();
}
function initMenuButtons(menu, source) {
  menu.$buttons.forEach(function (button) {
    button.menu = menu;
    button.source = source;
    button.type = 'button';
    button.addEventListener('click', handleClick);
    button.addEventListener('keydown', handleKeydown);
  });

  // If we're on mobile and using the slide layout, initialize back buttons
  if (source === 'mobile' && menu.$headerNavWrapper.classList.contains(HEADER_NAV_WRAPPER_SLIDE_CLASS)) {
    var backButtons = document.querySelectorAll(MENU_BACK_BUTTON_SELECTOR);
    backButtons.forEach(function (backEl) {
      backEl.menu = menu;
      backEl.source = source;
      backEl.addEventListener('click', handleClick);
      backEl.addEventListener('keydown', handleKeydown);
    });
  }
}
function initMenuLinks(menu, source) {
  menu.$links.forEach(function (link) {
    link.menu = menu;
    link.source = source;
    link.type = 'link';
    link.addEventListener('click', handleClick);
    link.addEventListener('keydown', handleKeydown);
    link.addEventListener('focus', handleFocus);
  });
}
function initLevelOneTriggerFocus(menu, source) {
  var selector = source === 'mobile' ? MOBILE_LEVEL1_TRIGGER_FOCUS_SELECTOR : DESKTOP_LEVEL1_TRIGGER_FOCUS_SELECTOR;
  document.querySelectorAll(selector).forEach(function (trigger) {
    trigger.menu = menu;
    trigger.source = source;
    trigger.addEventListener('focus', handleFocus);
  });
}
function getDesktopTopLevelControl(item) {
  return item.querySelector(MENU_TRIGGER_SELECTOR) || item.querySelector(DESKTOP_MEGA_PARENT_SELECTOR);
}
function initDesktopHover(topLevelItems) {
  topLevelItems.forEach(function (item) {
    var dropdown = item.querySelector(':scope > .header-menu__list--level-2');
    item.addEventListener('mouseenter', function () {
      clearTimeout(item.__menuCloseTimer);
      item.__menuCloseTimer = null;
      clearTimeout(item.__menuOpenTimer);
      var control = getDesktopTopLevelControl(item);

      // Track whether a sibling dropdown is already open so we can swap
      // instantly. Read this BEFORE closing the sibling.
      var switchingFromOpen = false;
      topLevelItems.forEach(function (other) {
        if (other !== item) {
          clearTimeout(other.__menuCloseTimer);
          clearTimeout(other.__menuOpenTimer);
          other.__menuCloseTimer = null;
          other.__menuOpenTimer = null;
          if (other.classList.contains(OPEN_CLASS)) {
            switchingFromOpen = true;
          }
          closeDropdown(other, getDesktopTopLevelControl(other));
        }
      });
      if (switchingFromOpen) {
        item.__menuOpenTimer = null;
        openDropdown(item, control);
      } else {
        item.__menuOpenTimer = setTimeout(function () {
          item.__menuOpenTimer = null;
          openDropdown(item, control);
        }, MENU_HOVER_OPEN_DELAY_MS);
      }
    });
    item.addEventListener('mouseleave', function () {
      clearTimeout(item.__menuOpenTimer);
      item.__menuOpenTimer = null;
      var control = getDesktopTopLevelControl(item);
      item.__menuCloseTimer = setTimeout(function () {
        item.__menuCloseTimer = null;
        closeDropdown(item, control);
      }, MENU_HOVER_CLOSE_DELAY_MS);
    });
    if (dropdown) {
      dropdown.addEventListener('mouseenter', function () {
        clearTimeout(item.__menuCloseTimer);
        item.__menuCloseTimer = null;
      });
      dropdown.addEventListener('mouseleave', function () {
        var control = getDesktopTopLevelControl(item);
        item.__menuCloseTimer = setTimeout(function () {
          item.__menuCloseTimer = null;
          closeDropdown(item, control);
        }, MENU_HOVER_CLOSE_DELAY_MS);
      });
    }
  });
}
function initMegaPanelClose(menu) {
  var closeButtons = document.querySelectorAll(MEGA_PANEL_CLOSE_SELECTOR);
  closeButtons.forEach(function (button) {
    button.menu = menu;
    button.addEventListener('click', function (event) {
      event.preventDefault();
      var parentItem = button.closest(MENU_ITEM_SELECTOR);
      var control = parentItem ? getDesktopTopLevelControl(parentItem) : null;
      if (parentItem) {
        closeDropdown(parentItem, control);
        if (control) {
          control.focus();
        }
      }
    });
  });
}
function handleClick(event) {
  var $this = event.currentTarget;
  event.stopPropagation();

  // Native `<button class="back__button">` reports `type === 'button'` — handle before triggers.
  if ($this.classList.contains(MENU_BACK_BUTTON_CLASS)) {
    event.preventDefault();
    var item = $this.closest(MENU_ITEM_SELECTOR);
    var levelTrigger = item ? item.querySelector(MENU_TRIGGER_SELECTOR) : null;
    if (item) {
      closeDropdown(item, levelTrigger);
    }
    return;
  }
  if ($this.type === 'button') {
    handleMenuButtonInteraction($this, event);
  } else {
    handleMenuLinkInteraction($this, event);
  }
}
function handleKeydown(event) {
  event.stopPropagation();
  handleKeyboardInteraction(event.currentTarget, event);
}
function handleFocus(event) {
  var link = event.currentTarget;
  var parentItem = link.parentElement;
  if (!parentItem || !parentItem.classList.contains(LEVEL_1_MENU_ITEM_CLASS)) {
    return;
  }
  if (link.menu.$topLevelItems) {
    link.menu.$topLevelItems.forEach(function (item) {
      if (item === parentItem) {
        return;
      }
      var control = getDesktopTopLevelControl(item);
      closeDropdown(item, control);
    });
  }
}
function handleMenuButtonInteraction(button, event) {
  event.preventDefault();
  var parentItem = button.closest(MENU_ITEM_SELECTOR);
  if (parentItem.classList.contains(OPEN_CLASS)) {
    closeDropdown(parentItem, button);
  } else {
    openDropdown(parentItem, button);

    // If we're using the slide layout and the button is top level, move focus to child
    // level back button
    if (button.source === 'mobile') {
      if (button.menu.$headerNavWrapper.classList.contains(HEADER_NAV_WRAPPER_SLIDE_CLASS)) {
        if (parentItem.classList.contains(LEVEL_1_MENU_ITEM_CLASS)) {
          var backButton = parentItem.querySelector(MENU_BACK_BUTTON_SELECTOR);

          // Delay setting the focus so that there's time for it to become visible
          setTimeout(function () {
            backButton.focus();
          }, 30);
        }
      }
    }
  }
}
function handleMenuLinkInteraction(link, event) {
  var href = link.getAttribute('href');
  var path = window.location.pathname;
  var isCurrentLink = href === path;
  var isCurrentLinkOrAnchor = false;
  if (link.classList.contains(MENU_LINK_EMPTY_CLASS) || isCurrentLink) {
    isCurrentLinkOrAnchor = true;
  }
  if (isCurrentLinkOrAnchor) {
    event.preventDefault();
    if (link.source === 'mobile') {
      closeMenu(link.menu);
    } else {
      var topLevelItem = link.closest(DESKTOP_TOP_MENU_ITEM_SELECTOR);
      var control = topLevelItem ? getDesktopTopLevelControl(topLevelItem) : null;
      if (topLevelItem) {
        closeDropdown(topLevelItem, control);
      }
    }
  } else {
    if (event.key === ' ') {
      event.preventDefault();
      window.location.assign(href);
    }
  }
}
function handleKeyboardInteraction(element, event) {
  var key = event.key;
  if (INTERACTION_KEYS.includes(key)) {
    if (key === ' ' || key === 'Enter') {
      // If the current element is a button, toggle the dropdown
      // If it's a back button, close the current dropdown and move focus back to the parent
      // Otherwise, it's a link
      if (element.classList.contains(MENU_TRIGGER_CLASS)) {
        handleMenuButtonInteraction(element, event);
      } else if (element.classList.contains(MENU_BACK_BUTTON_CLASS)) {
        event.preventDefault();
        var parentItem = element.closest(MENU_ITEM_SELECTOR);
        var parentTrigger = parentItem ? parentItem.querySelector(MENU_TRIGGER_SELECTOR) : null;
        if (parentItem) {
          closeDropdown(parentItem, parentTrigger);
        }
        if (parentTrigger) {
          parentTrigger.focus();
        }
      } else if (key === 'Enter') {
        handleMenuLinkInteraction(element, event);
      }
    } else if (key === 'Escape') {
      // Find the closest parent dropdown, close it, and focus the associated button
      if (element.source === 'mobile') {
        var closestOpenDropdown;
        if (element.classList.contains(MENU_TRIGGER_CLASS) || element.classList.contains(MENU_BACK_BUTTON_CLASS)) {
          closestOpenDropdown = element.closest(OPEN_MENU_ITEM_SELECTOR);
        } else {
          closestOpenDropdown = element.closest(MENU_ITEM_SELECTOR);
        }
        if (closestOpenDropdown !== null) {
          var trigger = closestOpenDropdown.querySelector(MENU_TRIGGER_SELECTOR);
          closeDropdown(closestOpenDropdown, trigger);
          if (trigger) {
            trigger.focus();
          }
        } else {
          closeMenu(element.menu);
        }
      } else {
        var topLevelItem = element.closest(DESKTOP_TOP_MENU_ITEM_SELECTOR);
        var control = topLevelItem ? getDesktopTopLevelControl(topLevelItem) : null;
        if (topLevelItem) {
          closeDropdown(topLevelItem, control);
          if (control) {
            control.focus();
          }
        }
      }
    } else if (key === 'Tab') {
      // If we're on mobile, using the slide layout, and inside a level 2 menu, keep tab focus
      // from leaving the menu
      if (element.source === 'mobile') {
        if (element.menu.$headerNavWrapper.classList.contains(HEADER_NAV_WRAPPER_SLIDE_CLASS)) {
          var parentList = element.closest(MENU_LIST_SELECTOR);
          if (parentList.classList.contains(LEVEL_2_MENU_LIST_CLASS)) {
            var $this = event.target;
            var focusableElements = parentList.querySelectorAll('[tabindex="0"]');
            var firstFocusableElement = focusableElements[0];
            var lastFocusableElement = focusableElements[focusableElements.length - 1];
            if (event.shiftKey) {
              if ($this === firstFocusableElement) {
                event.preventDefault();
                lastFocusableElement.focus();
              }
            } else if ($this === lastFocusableElement) {
              event.preventDefault();
              firstFocusableElement.focus();
            }
          }
        }
      }
    }
  }
}
function closeMenu(menu) {
  menu.$body.classList.remove(NO_SCROLL_CLASS);
  menu.$header.classList.remove(OPEN_CLASS);
  menu.$hamburger.classList.remove(OPEN_CLASS);
  removeClassFromElements(menu.$items, OPEN_CLASS);
  setAttributeForElements(menu.$buttons, 'aria-expanded', 'false');
}
function openDropdown(item, trigger) {
  item.classList.add(OPEN_CLASS);
  if (trigger && trigger.hasAttribute('aria-expanded')) {
    trigger.setAttribute('aria-expanded', 'true');
  }
  syncDesktopMenuOpenClass();
}
function closeDropdown(item, trigger) {
  item.classList.remove(OPEN_CLASS);
  if (trigger && trigger.hasAttribute('aria-expanded')) {
    trigger.setAttribute('aria-expanded', 'false');
  }
  var childList = item.querySelector(MENU_LIST_SELECTOR);
  if (childList) {
    var childListDropdownItems = childList.querySelectorAll(MENU_ITEM_SELECTOR);
    childListDropdownItems.forEach(function (childItem) {
      var childControl = childItem.querySelector(MENU_TRIGGER_SELECTOR) || childItem.querySelector(DESKTOP_MEGA_PARENT_SELECTOR);
      childItem.classList.remove(OPEN_CLASS);
      if (childControl && childControl.hasAttribute('aria-expanded')) {
        childControl.setAttribute('aria-expanded', 'false');
      }
    });
  }
  syncDesktopMenuOpenClass();
}

/** Toggles a section-level class whenever a desktop top-level dropdown is
 * open, so transparent (homepage hero) header styles can swap to solid white
 * without waiting for `.is-sticky` from the scroll handler. Cheap to call on
 * every open/close — single DOM query, idempotent class toggle. */
function syncDesktopMenuOpenClass() {
  var headerSection = document.querySelector(HEADER_SECTION_SELECTOR);
  if (!headerSection) return;
  var hasOpenDesktopItem = document.querySelector(DESKTOP_OPEN_TOP_MENU_ITEM_SELECTOR);
  headerSection.classList.toggle(MENU_OPEN_CLASS, Boolean(hasOpenDesktopItem));
}
function initDesktopMenuDocumentScrollClose() {
  if (desktopMenuDocumentScrollCloseBound) {
    return;
  }
  desktopMenuDocumentScrollCloseBound = true;
  window.addEventListener('scroll', handleDesktopMenuDocumentScroll, {
    passive: true
  });
}
function handleDesktopMenuDocumentScroll() {
  if (window.matchMedia(MOBILE_MENU_MEDIA_QUERY).matches) {
    return;
  }
  document.querySelectorAll(DESKTOP_OPEN_TOP_MENU_ITEM_SELECTOR).forEach(function (item) {
    clearTimeout(item.__menuCloseTimer);
    clearTimeout(item.__menuOpenTimer);
    item.__menuCloseTimer = null;
    item.__menuOpenTimer = null;
    closeDropdown(item, getDesktopTopLevelControl(item));
  });
}
function removeClassFromElements(elems, className) {
  elems.forEach(function (elem) {
    elem.classList.remove(className);
  });
}
function setAttributeForElements(elems, attribute, value) {
  elems.forEach(function (elem) {
    elem.setAttribute(attribute, value);
  });
}
function setActiveTopLevelLinks() {
  var currentPath = window.location.pathname.replace(/\/$/, '') || '/';
  var links = document.querySelectorAll(DESKTOP_TOP_MENU_LINK_SELECTOR);
  links.forEach(function (link) {
    var rawHref = link.getAttribute('href');
    if (!rawHref || rawHref === '#') {
      return;
    }
    var url = new URL(rawHref, window.location.origin);
    var hrefPath = url.pathname.replace(/\/$/, '') || '/';
    if (hrefPath === currentPath) {
      link.classList.add('header-menu__link--active');
    }
  });
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', function () {
  var mobileMedia = window.matchMedia(MOBILE_MENU_MEDIA_QUERY);
  if (mobileMedia.matches) {
    initMobileMenu();
  } else {
    initDesktopMenu();
  }
});
window.addEventListener('resize', function () {
  var mobileMedia = window.matchMedia(MOBILE_MENU_MEDIA_QUERY);
  if (mobileMedia.matches) {
    initMobileMenu();
  } else {
    initDesktopMenu();
  }
});